<template>
    <div class="context">
        <el-popover
                placement="bottom"
                width="200"
                @show="open_popover"
                trigger="click">
            <div class="select_btn">
                <div class="search_input" v-if="!not_search">
                    <el-input v-model="inputValue"
                              size="mini"
                              placeholder="请输入名称"
                              clearable
                              class="width_200">
                        <el-button slot="append" @click="input_submit" icon="el-icon-search"></el-button>
                    </el-input>
                </div>
                <el-checkbox v-if="!only_search" :indeterminate="checkHalf"
                             v-model="checkAll"
                             @change="handleCheckAllChange">
                    全选
                </el-checkbox>
                <el-checkbox-group v-if="!only_search"
                                   v-model="select_list"
                                   class="check_group_box"
                                   @change="handleCheckChange">
                    <el-checkbox v-for="item in filterList"
                                 :key="item"
                                 class="checkbox_item"
                                 :label="item"
                    >{{item}}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="btn" v-if="!only_search">
                <el-button size="mini" @click="refreshSearch">重置</el-button>
                <el-button size="mini" type="primary" @click="searchTableData">确定</el-button>
            </div>
            <div slot="reference" style="cursor: pointer">
                <span>{{label}}</span>
                <i class="el-icon-caret-bottom"></i>
            </div>
        </el-popover>
    </div>
</template>

<script>
    import {clone} from "@/global/utils";

    export default {
        name: "table_search",
        data() {
            return {
                inputValue: '',

                select_list: [],

                checkHalf: false,
                checkAll: false,
            }
        },
        props: [
            'list',
            'search_list',
            'search_name',
            'label',
            'not_search',
            'only_search',
        ],
        computed: {
            filterList() {
                return this.list.filter(data => !this.inputValue || data.includes(this.inputValue))
            },
        },
        watch: {
            search_list() {
                this.select_list = clone(this.search_list)
            },
            inputValue() {
                // this.open_popover()
            }
        },
        mounted() {

        },
        methods: {
            open_popover() {
                this.checkHalf = false;
                this.checkAll = false;

                if(this.select_list.length === 0) {

                } else if (this.select_list.length === this.filterList.length) {
                    this.checkAll = true;
                } else {
                    this.checkHalf = true;
                }
            },

            handleCheckAllChange(val) {
                this.select_list = val ? this.filterList : [];
                this.checkHalf = false;
            },
            handleCheckChange(val) {
                this.checkAll = val.length === this.filterList.length;
                this.checkHalf = val.length > 0 && val.length < this.filterList.length;
            },

            refreshSearch() {
                this.select_list = [];
                this.checkHalf = false;
                this.checkAll = false;
                this.$forceUpdate()
            },
            searchTableData() {
                let data = {
                    name: this.search_name,
                    list: this.select_list
                };
                this.$emit('popover_getTable', data)
            },

            input_submit() {
                if(!this.only_search) return;
                let data = {
                    name: this.search_name,
                    list: this.inputValue
                };
                this.$emit('popover_getTable', data)
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
    .select_btn {
        line-height: 25px;
        .search_input {
            margin-bottom: 10px;
        }
        .check_group_box {
            max-height: 600px;
            overflow: hidden;
            overflow-y: auto;
            .checkbox_item {
                display: block;
                padding-left: 20px;
            }
        }
    }
    .btn {
        margin-top: 10px;
        text-align: right;
    }
</style>